import usePrevious from 'hooks/usePrevious'
import { clsx } from 'clsx'

const NumberFlash = ({
  number,
  className,
  prefix,
  suffix,
}: {
  number: string
  className?: string
  prefix?: string
  suffix?: string
}) => {
  const previousNumber = usePrevious(Number(number))
  return (
    <span
      className={clsx(
        {
          'green-flash': previousNumber != null && +number > previousNumber,
          'red-flash': previousNumber != null && +number < previousNumber,
        },
        className,
      )}
    >
      {prefix}
      {number}
      {suffix}
    </span>
  )
}

export default NumberFlash
